// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__32PGD","errors":"Errors_errors__3wLSX"};